import { configureStore } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import educationalQualificationReducer from '../slices/educationalQualificationSlice';
import personalDetailsReducer from '../slices/personalDetailSlice';
import valueAddsSlice from '../slices/valueAddsSlice';
import workExperienceReducer from '../slices/WorkExperienceSlice';
import compensationDetailsReducer from '../slices/compensationDetailsSlice';
import fileUploadSliceReducer from '../slices/fileUploadSlice';
import candidateNavigationSlice from '../slices/candidateNavigationUpdate';


export default configureStore({
  reducer: {
    form: formReducer,
    educationDetails: educationalQualificationReducer,
    personalDetails: personalDetailsReducer,
    workExperience: workExperienceReducer,
    valueAddDetails: valueAddsSlice,
    compensationDetails: compensationDetailsReducer,
    fileUploads: fileUploadSliceReducer,
    candidateNavigation: candidateNavigationSlice,
  },
  devTools: true
});
